module.exports = __webpack_public_path__ + "static/img/pc2@2x.a4a71633.png";